import React, { memo } from 'react';
import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';

const BondSectionTemplate = ({
    children,
    className = '',
    title,
    description,
    ...props
}) => {
    return (
        <section
            className={cn(
                'flex flex-col gap-4 pb-6 xl:pb-2 border-b border-gray-300 mx-0',
                className
            )}
            {...props}
        >
            {title && (
                <Text content={title} className="h5-bold text-primary-500" />
            )}
            {description && (
                <Text content={description} className="text-gray-900 p4-bold" />
            )}
            {children}
        </section>
    );
};

export default memo(BondSectionTemplate);
